import React from "react";

function Cards() {
  return (
    <div style={{color:"crimson"}}>
      <h1>I am in Card Section</h1>
    </div>
  );
}

export default Cards;
